import React from 'react';
import { MountainIcon, WavesIcon, TreesIcon, FlagIcon, AlertTriangleIcon, NavigationIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function CompetitionMap() {
  const {
    t
  } = useLanguage();
  return <section id="map" className="w-full bg-black py-20 md:py-28 px-4" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-3">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-4">
            {t('map.knowBattlefield')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-5">
            {t('map.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-6">
            {t('map.subtitle')}
          </p>
        </div>

        {/* Map Container */}
        <div className="relative bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden" data-id="element-7">
          {/* Stylized Map Background */}
          <div className="relative w-full aspect-[16/10] md:aspect-[16/8]" data-id="element-8">
            <div className="absolute inset-0 bg-cover bg-center opacity-40" style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1600&q=80)'
          }} aria-hidden="true" data-id="element-9" />
            <div className="absolute inset-0 bg-gradient-to-b from-neutral-900/60 via-transparent to-neutral-900/80" aria-hidden="true" data-id="element-10" />

            {/* Course Path SVG */}
            <img src="https://cdn.magicpatterns.com/uploads/8qNQgsnrR5jdmpmjSsQqHW/ef1c20e5-500f-4215-a19a-91561088a7dd.png" alt="Sacensību trase" className="absolute inset-0 w-full h-full object-cover" data-id="element-11" />

            {/* Point of Interest Markers */}
            {/* Start/Finish */}
            <div className="absolute left-[8%] top-[78%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-12">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-green-500/30" data-id="element-13">
                {t('map.startFinish')}
              </div>
            </div>

            {/* Rock Garden */}
            <div className="absolute left-[27%] top-[45%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-14">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-orange-500/30" data-id="element-15">
                {t('map.rockGardenTechnical')}
              </div>
            </div>

            {/* River Crossing */}
            <div className="absolute left-[44%] top-[38%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-16">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-blue-500/30" data-id="element-17">
                {t('map.riverCrossing')}
              </div>
            </div>

            {/* Forest Trail */}
            <div className="absolute left-[60%] top-[42%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-18">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-emerald-600/30" data-id="element-19">
                {t('map.denseForestTrail')}
              </div>
            </div>

            {/* Vertical Climb */}
            <div className="absolute left-[78%] top-[28%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-20">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-red-500/30" data-id="element-21">
                {t('map.verticalClimb')}
              </div>
            </div>

            {/* Checkpoint */}
            <div className="absolute left-[88%] top-[55%] transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" data-id="element-22">
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-black rounded-lg text-xs text-white whitespace-nowrap border border-yellow-500/30" data-id="element-23">
                {t('map.checkpoint')}
              </div>
            </div>
          </div>

          {/* Legend */}
          <div className="p-6 border-t border-neutral-800 bg-neutral-900/80" data-id="element-24">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-25">
              {t('map.legend')}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-id="element-26">
              <div className="flex items-center gap-2" data-id="element-27">
                <div className="w-4 h-4 rounded-full bg-green-500 flex-shrink-0" data-id="element-28" />
                <span className="text-xs text-gray-400" data-id="element-29">{t('map.info')}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-30">
                <div className="w-4 h-4 rounded-full bg-orange-500 flex-shrink-0" data-id="element-31" />
                <span className="text-xs text-gray-400" data-id="element-32">{t('map.about')}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-33">
                <div className="w-4 h-4 rounded-full bg-blue-500 flex-shrink-0" data-id="element-34" />
                <span className="text-xs text-gray-400" data-id="element-35">
                  {t('map.crossings')}
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-36">
                <div className="w-4 h-4 rounded-full bg-emerald-600 flex-shrink-0" data-id="element-37" />
                <span className="text-xs text-gray-400" data-id="element-38">
                  {t('map.nearest')}
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-39">
                <div className="w-4 h-4 rounded-full bg-red-500 flex-shrink-0" data-id="element-40" />
                <span className="text-xs text-gray-400" data-id="element-41">{t('map.time')}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-42">
                <div className="w-4 h-4 rounded-full bg-yellow-500 flex-shrink-0" data-id="element-43" />
                <span className="text-xs text-gray-400" data-id="element-44">{t('map.join')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Obstacle Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8" data-id="element-45">
          {/* Rock Garden */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-orange-500/30 transition-colors" data-id="element-46">
            <div className="flex items-center gap-3 mb-3" data-id="element-47">
              <MountainIcon className="h-5 w-5 text-orange-500" data-id="element-48" />
              <h4 className="font-bold text-white" data-id="element-49">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-50"></p>
            <span className="text-xs font-semibold text-orange-500 uppercase" data-id="element-51">
              {t('map.difficultyHigh')}
            </span>
          </div>

          {/* River Crossing */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-blue-500/30 transition-colors" data-id="element-52">
            <div className="flex items-center gap-3 mb-3" data-id="element-53">
              <WavesIcon className="h-5 w-5 text-blue-500" data-id="element-54" />
              <h4 className="font-bold text-white" data-id="element-55">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-56"></p>
            <span className="text-xs font-semibold text-blue-500 uppercase" data-id="element-57">
              {t('map.difficultyMedium')}
            </span>
          </div>

          {/* Forest Trail */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-emerald-500/30 transition-colors" data-id="element-58">
            <div className="flex items-center gap-3 mb-3" data-id="element-59">
              <TreesIcon className="h-5 w-5 text-emerald-500" data-id="element-60" />
              <h4 className="font-bold text-white" data-id="element-61">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-62"></p>
            <span className="text-xs font-semibold text-emerald-500 uppercase" data-id="element-63">
              {t('map.difficultyMedium')}
            </span>
          </div>

          {/* Vertical Climb */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-red-500/30 transition-colors" data-id="element-64">
            <div className="flex items-center gap-3 mb-3" data-id="element-65">
              <AlertTriangleIcon className="h-5 w-5 text-red-500" data-id="element-66" />
              <h4 className="font-bold text-white" data-id="element-67">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-68"></p>
            <span className="text-xs font-semibold text-red-500 uppercase" data-id="element-69">
              {t('map.difficultyExtreme')}
            </span>
          </div>

          {/* Card 5 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-yellow-500/30 transition-colors" data-id="element-70">
            <div className="flex items-center gap-3 mb-3" data-id="element-71">
              <FlagIcon className="h-5 w-5 text-yellow-500" data-id="element-72" />
              <h4 className="font-bold text-white" data-id="element-73">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-74"></p>
            <span className="text-xs font-semibold text-yellow-500 uppercase" data-id="element-75">
              {t('map.difficultyLow')}
            </span>
          </div>

          {/* Card 6 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-purple-500/30 transition-colors" data-id="element-76">
            <div className="flex items-center gap-3 mb-3" data-id="element-77">
              <NavigationIcon className="h-5 w-5 text-purple-500" data-id="element-78" />
              <h4 className="font-bold text-white" data-id="element-79">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-80"></p>
            <span className="text-xs font-semibold text-purple-500 uppercase" data-id="element-81">
              {t('map.difficultyMedium')}
            </span>
          </div>

          {/* Card 7 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-orange-500/30 transition-colors" data-id="element-82">
            <div className="flex items-center gap-3 mb-3" data-id="element-83">
              <MountainIcon className="h-5 w-5 text-orange-500" data-id="element-84" />
              <h4 className="font-bold text-white" data-id="element-85">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-86"></p>
            <span className="text-xs font-semibold text-orange-500 uppercase" data-id="element-87">
              {t('map.difficultyHigh')}
            </span>
          </div>

          {/* Card 8 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-blue-500/30 transition-colors" data-id="element-88">
            <div className="flex items-center gap-3 mb-3" data-id="element-89">
              <WavesIcon className="h-5 w-5 text-blue-500" data-id="element-90" />
              <h4 className="font-bold text-white" data-id="element-91">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-92"></p>
            <span className="text-xs font-semibold text-blue-500 uppercase" data-id="element-93">
              {t('map.difficultyHigh')}
            </span>
          </div>

          {/* Card 9 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-emerald-500/30 transition-colors" data-id="element-94">
            <div className="flex items-center gap-3 mb-3" data-id="element-95">
              <TreesIcon className="h-5 w-5 text-emerald-500" data-id="element-96" />
              <h4 className="font-bold text-white" data-id="element-97">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-98"></p>
            <span className="text-xs font-semibold text-emerald-500 uppercase" data-id="element-99">
              {t('map.difficultyMedium')}
            </span>
          </div>

          {/* Card 10 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 hover:border-red-500/30 transition-colors" data-id="element-100">
            <div className="flex items-center gap-3 mb-3" data-id="element-101">
              <AlertTriangleIcon className="h-5 w-5 text-red-500" data-id="element-102" />
              <h4 className="font-bold text-white" data-id="element-103">
                {t('map.infoComingSoon')}
              </h4>
            </div>
            <p className="text-sm text-gray-400 mb-3" data-id="element-104"></p>
            <span className="text-xs font-semibold text-red-500 uppercase" data-id="element-105">
              {t('map.difficultyExtreme')}
            </span>
          </div>
        </div>
      </div>
    </section>;
}